import React from 'react';
import { TooltipKeys } from '../../tooltips/TooltipKeys';
import UIProjectOptions  from '../subcomponents/UIProjectOptions';
import UINextStep  from '../subcomponents/UINextStep';
import UIVoice  from '../subcomponents/UIVoice';
import subComponentTypes from '../subcomponents/types';
import UIEditorComponentRenderer from '../UIEditorComponentRenderer';

export default function TIntroSplash(props)
{
	function getRawProperties()
	{
		return {
			[subComponentTypes.PROJECT_OPTIONS]:{ ...UIProjectOptions({ ...props }) },
			[subComponentTypes.NEXT_STEP]:{ ...UINextStep({ ...props }) },
			[subComponentTypes.VOICE]:{ ...UIVoice({ ...props }) }
		}
	}

	if(props.getProperties)
	{
		return getRawProperties();
	}

	function repackProperties()
	{
		let rawProperties = getRawProperties();
		let flatProperties = [
			{
				type: 'group',
				key: 'project options group',
				title: rawProperties.ProjectOptions.props.title,
				subcomponent: null,
				decorator: {
					...rawProperties.ProjectOptions.props.properties['visible'],
					key: 'visible',
					type: 'toggle-icon',
					subcomponent: rawProperties.ProjectOptions.props.subcomponent,
					title: '',
				},
				children: [
					{
						...rawProperties.ProjectOptions.props.properties['scenario logo'],
						key: 'scenario logo',
						subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						title: "Scenario Logo",
					},
					{
						...rawProperties.ProjectOptions.props.properties['company logo'],
						key: 'company logo',
						subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						title: "Company Logo",
					},
					{
						...rawProperties.ProjectOptions.props.properties.title,
						key: 'title',
						subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						title: "",
					},
					{
						type: 'color-alpha',
						title: "Title",
						color: {
							...rawProperties.ProjectOptions.props.properties['title color'],
							key: 'title color',
							subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						},
						alpha: {
							...rawProperties.ProjectOptions.props.properties['title alpha'],
							key: 'title alpha',
							subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						},
					},
					{
						...rawProperties.ProjectOptions.props.properties.subtitle,
						key: 'subtitle',
						subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						title: "",
					},
					{
						type: 'color-alpha',
						title: "Subtitle",
						color: {
							...rawProperties.ProjectOptions.props.properties['subtitle color'],
							key: 'subtitle color',
							subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						},
						alpha: {
							...rawProperties.ProjectOptions.props.properties['subtitle alpha'],
							key: 'subtitle alpha',
							subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						},
					},
					{
						type: 'color-alpha',
						title: "Background",
						color: {
							...rawProperties.ProjectOptions.props.properties['background color'],
							key: 'background color',
							subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						},
						alpha: {
							...rawProperties.ProjectOptions.props.properties['background alpha'],
							key: 'background alpha',
							subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						},
					},
					{
						...rawProperties.ProjectOptions.props.properties['anchor'],
						key: 'anchor',
						subcomponent: rawProperties.ProjectOptions.props.subcomponent,
						title: "Anchor",
					},
				]
			},
			{
				...rawProperties.NextStep.props.properties.visible,
				key: 'visible',
				subcomponent: rawProperties.NextStep.props.subcomponent,
				title: rawProperties.NextStep.props.title,
			},
			{
				type: 'group',
				key: 'voice group',
				tooltip: TooltipKeys.UIVoice,
				title: rawProperties.Voice.props.title,
				subcomponent: null,
				children: [
					{
						...rawProperties.Voice.props.properties.Voice,
						key: 'Voice',
						subcomponent: rawProperties.Voice.props.subcomponent,
						title: "",
					}
				]

                
			},
		]
		return <UIEditorComponentRenderer
			{...props}
			properties={flatProperties}
		/>;
	}
	return (
		props.context === 'editor' ? 
			<>
				{repackProperties()}
			</>
			:
			<>
				<UIProjectOptions {...props} />
				<UINextStep {...props} />
				<UIVoice {...props} />
			</>
	);
}